import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "tss-react/mui";
import React, { useState } from "react";
import { THEME_COLORS } from "../../themes";

// TODO: DELETE
function MultiSelectV3({ title }) {
  const { classes } = useStyles();
  const [selected, setSelected] = useState([]);
  const isAllSelected = options.length > 0 && selected.length === options.length;

  const handleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      return;
    }
    setSelected(value);
  };

  return (
    <FormControl variant="outlined" className={classes.formControl} margin="dense">
      <Select
        labelId="mutiple-select-label"
        multiple
        value={selected}
        onChange={handleChange}
        classes={{ root: classes.selectRoot }}
        displayEmpty
        renderValue={(selected) => title + ": " + selected.join(", ")}
        MenuProps={MenuProps}
      >
        <MenuItem
          value="all"
          disableGutters
          classes={{
            root: classes.menuItem,
          }}
        >
          <ListItemIcon classes={{ root: classes.listIcon }}>
            <Checkbox
              classes={{ indeterminate: classes.indeterminateColor }}
              checked={isAllSelected}
              color="primary"
              indeterminate={selected.length > 0 && selected.length < options.length}
            />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.selectAllText }} primary="Select All" />
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            disableGutters
            classes={{
              root: classes.menuItem,
            }}
            key={option}
            value={option}
          >
            <ListItemIcon classes={{ root: classes.listIcon }}>
              <Checkbox
                color="primary"
                checkedIcon={<CheckBoxOutlinedIcon />}
                checked={selected.indexOf(option) > -1}
              />
            </ListItemIcon>
            <ListItemText
              primary={option}
              primaryTypographyProps={{ style: { color: THEME_COLORS.textGrey, fontSize: 14 } }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

const useStyles = makeStyles()((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 240,
  },
  indeterminateColor: {
    color: THEME_COLORS.purple2,
  },
  selectAllText: {
    fontWeight: 500,
    fontSize: 14,
  },
  menuItem: {
    backgroundColor: THEME_COLORS.sideMenuBg,
    padding: "2px 4px",
    "&:hover, &:focus": {
      backgroundColor: THEME_COLORS.purple3,
    },
  },
  selectRoot: {
    padding: theme.spacing(1),
    fontSize: 14,
  },
  listIcon: {
    minWidth: theme.spacing(2),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
      backgroundColor: THEME_COLORS.sideMenuBg,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom" as const,
    horizontal: "center" as const,
  },
  transformOrigin: {
    vertical: "top" as const,
    horizontal: "center" as const,
  },
  variant: "menu" as const,
};

const options = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

export { MultiSelectV3 };
